import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=434628cb&"
import script from "./Achievements.vue?vue&type=script&lang=js&"
export * from "./Achievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports